import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ContentTypesFilter = ({
    eventContentTypes = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --contentType'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='eventContentTypes'
        options={eventContentTypes}
        placeholder='Content type'
        search
        setValue={restoreFilterValues(filters, 'eventContentTypes')}
    />
);

ContentTypesFilter.propTypes = {
    eventContentTypes: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
